const TEXT = {
    PERSONAL_DETAILS: {
        HEADING: "Kontaktinfo",
        HEADING_SUMMARY: "Oppsummering",
        HEADING_RECEIPT: "Oppsummering av din bestilling",
        HEADING_BANK_ID_VERIFIED: "Vi hentet disse opplysningene fra BankID",
        BANK_ID_MANDATORY_BUT_NOT_AVAILABLE:
            "Dette steget krever verifisering med BankID, men BankID ser ut til å være nede. Vennligst prøv igjen senere.",
        FIRSTNAME: "Fornavn",
        LASTNAME: "Etternavn",
        BIRTHDATE: "Fødselsdato",
        POSTCODE: "Postnummer",
        CITY: "Poststed",
        STREET: "Adressen antennen skal leveres",
        EMAIL: "E-post",
        PHONENUMBER: "Telefonnummer",
        ADDRESS: "Adresse",
    },
    PACKAGES: {
        PACKAGES_NOT_FOUND: "Ingen treff, men du kan fortsatt få internett",
        NOT_FOUND_OPTIONS_HEADING:
            "Vi kan dessverre ikke levere Trådløst Bredbånd på din adresse, men vi får deg på nett uansett. Velg gjerne et av følgende alternativer: ",
        INTERNET_HOME:
            "Ønsker du internett hjemme? <a class='link' href='https://www.telia.no/internett/bredband/#skjema' target='_blank'>Ta kontakt med oss</a>, så finner vi beste løsning for deg.",
        INTERNET_CABIN:
            "Ønsker du internett på hytta? Da er mobilt bredbånd et godt alternativ <a class='link' href='https://www.telia.no/internett/mobilt-bredband/' target='_blank'>les mer og bestill her</a>.",
        FIRST_YEAR_DISCOUNT_INFO: (discountedPrice: number) => `${discountedPrice},-/md. i rabatt første 12 md.`,
    },
    BUTTON: {
        CHECK: "Sjekk",
        ORDER: "Bekreft bestilling",
        HOMEPAGE: "Tilbake til butikken",
        TELIANO_PAGE: "Tilbake til telia.no",
        BACK: "Tilbake",
    },
    RECEIPT: {
        HEADING: "Takk for din bestilling!",
        ORDER: {
            ORDERCONFIRMATION: "Du vil få en ordrebekreftelse med faktura på e-post.",
        },
        INSTALLATION: {
            HEADING: "Dette vil skje fremover:",
            PARAGRAPH:
                "En av våre medarbeidere vil ta kontakt med deg innen <span class=telia-sans-medium>1-2 virkedager </span> for å avtale tid for montering.",
            PARAGRAPH_DIY:
                "Din pakke med det du trenger for å sette opp Trådløst Bredbånd og TV blir sendt i posten til deg i løpet av noen få virkedager.",
        },
    },
    SUMMARY: {
        INFO: "Viktig informasjon om din første faktura. På første faktura blir du belastet for inneværende måned, i tillegg til to måneder frem i tid. Eventuelle rabatter trekkes fra totalsummen på fakturaen.",
        DISCLAIMER:
            "Din første faktura inkluderer inneværende måned pluss to måneder frem i tid. Rabatter trekkes automatisk fra.",
    },
};

export default TEXT;
